import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import styles from './jichuZhang.module.css';
import chuancheng from '../../img/chuancheng.png';
import fengxian from '../../img/fengxian.png';
import jianti from '../../img/jianti.png';
import jieyue from '../../img/jieyue.png';
import laodong from '../../img/laodong.png';
import lide from '../../img/lide.png';
import lizhi from '../../img/lizhi.png';
import mengxiang from '../../img/mengxiang.png';
import tuanjie from '../../img/tuanjie.png';
import xiangyang from '../../img/xiangyang.png';
import xiaozhuren from '../../img/xiaozhuren.png';
import yonggan from '../../img/yonggan.png';

class JichuZhang extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, []);

        this.state = {
            reasonList: props.jichuZhangList
        };

    }

    componentDidMount() {


    }

    render() {
        return (
            <div className={styles.root}>

                {
                    this.props.jichuZhangList.map((item, index) => {
                        return (
                            <div className={styles["item"]}
                            >
                                <div className={styles["container-top"]}>
                                    <img className={styles["img-hz"]} src={item.img == 'chuancheng.png' ? chuancheng :
                                        item.img == 'fengxian.png' ? fengxian :
                                            item.img == 'jianti.png' ? jianti :
                                                item.img == 'jieyue.png' ? jieyue :
                                                    item.img == 'laodong.png' ? laodong :
                                                        item.img == 'lide.png' ? lide :
                                                            item.img == 'lizhi.png' ? lizhi :
                                                                item.img == 'mengxiang.png' ? mengxiang :
                                                                    item.img == 'tuanjie.png' ? tuanjie :
                                                                        item.img == 'xiangyang.png' ? xiangyang :
                                                                            item.img == 'xiaozhuren.png' ? xiaozhuren :
                                                                                item.img == 'yonggan.png' ? yonggan : ''}/>
                                    <div>
                                        <div className={styles.name1}>{item.name1}</div>
                                        <div className={styles.name2}>{item.name2}</div>
                                    </div>

                                </div>
                                <div>
                                    {
                                        this.props.jichuZhangList[index].zhibiao.map((item2) => {
                                            return (
                                                <div className={styles["item-liyou"]}
                                                     onClick={this.props.clickLiyou.bind(null,item2.k)}
                                                >
                                                    {item2.v}
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        );
                    })
                }

            </div>
        );
    }
}


export default JichuZhang;
